import * as tslib_1 from "tslib";
import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';
/**
 * A Service/Repair search result returned by the AirportsAPI `~/service-repairs` endpoint. A service/repair
 * business is one carrying any `Maintenance::` tag, mirroring the iOS app's `tagPrefix: "Maintenance"`
 * classification. Mirrors {@link FboResult}'s `static parse` convention (minus fuel, which does not apply).
 */
/**
 * Maintenance categories (the 2nd segment of a `Maintenance::<Category>::...` tag), in display order. Used to
 * summarize what a shop covers on the results card.
 */
export var SERVICE_REPAIR_CATEGORY_ORDER = [
    'Airframe', 'Avionics', 'Powerplant', 'Propeller', 'Interior', 'Exterior', 'Rotor'
];
var ServiceRepairResult = /** @class */ (function (_super) {
    tslib_1.__extends(ServiceRepairResult, _super);
    function ServiceRepairResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceRepairResult.parse = function (data) {
        var tags = (data.tags || []).map(function (d) { return d; });
        var present = new Set();
        tags.forEach(function (t) {
            var parts = t.split('::');
            if (parts.length >= 2) {
                present.add(parts[1]);
            }
        });
        var categories = SERVICE_REPAIR_CATEGORY_ORDER.filter(function (c) { return present.has(c); });
        return Object.assign(new ServiceRepairResult(), {
            businessId: data.businessId,
            name: data.name || null,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            latitude: isNumeric(data.latitude) ? +data.latitude : null,
            longitude: isNumeric(data.longitude) ? +data.longitude : null,
            location: (isNumeric(data.latitude) && isNumeric(data.longitude))
                ? parseLatLon(data.latitude, data.longitude) : null,
            phone1: data.phone1 || null,
            webAddress: data.webAddress || null,
            emailAddress: data.emailAddress || null,
            description: data.description || null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            airportIdent: data.airportIdent || null,
            airportName: data.airportName || null,
            tags: tags,
            categories: categories,
            thumbnailPhotoPath: data.thumbnailPhotoPath || null
        });
    };
    return ServiceRepairResult;
}(BusinessFinderResult));
export { ServiceRepairResult };
